import { NafoCustomer } from '@monolith/legacy/types/order';
import { postNafoCustomer, patchNafoCustomer } from '@monolith/legacy/services/order/order.service';
import { v6setup } from 'uuid-with-v6';

interface State {
  customer: NafoCustomer;
  reference: string | null;
  extraInstructions: string | null;
  orderUUid: string | null;
  customsInvoiceUuid: string | null;
}

const initialState: State = {
  customer: null,
  reference: null,
  extraInstructions: null,
  orderUUid: v6setup({ disableRandom: true })(),
  customsInvoiceUuid: null
};

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    SET_CUSTOMER(state: State, customer: NafoCustomer): void {
      state.customer = customer;
    },
    SET_REFERENCE(state: State, reference: string): void {
      state.reference = reference;
    },
    GENERATE_NEW_ORDER_UUID(state: State): void {
      state.orderUUid = v6setup({ disableRandom: true })();
    },
    SET_EXTRA_INSTRUCTIONS(state: State, instructions: string): void {
      state.extraInstructions = instructions;
    },
    CLEAR_CUSTOMER(state: State): void {
      state.customer = null;
    },
    CLEAR_REFERENCE(state: State): void {
      state.reference = null;
    },
    CLEAR_EXTRA_INSTRUCTIONS(state: State): void {
      state.extraInstructions = null;
    },
    SET_CUSTOMS_INVOICE_UUID(state: State, uuid: string | null): void {
      state.customsInvoiceUuid = uuid;
    },
    CLEAR_CUSTOMS_INVOICE_UUID(state: State): void {
      state.customsInvoiceUuid = null;
    },
  },
  actions: {
    setCustomer: ({ commit }, { customerData }: { customerData: NafoCustomer }) => {
      commit('SET_CUSTOMER', customerData);
    },
    setReference: ({ commit }, { reference }: { reference: string }) => {
      commit('SET_REFERENCE', reference);
    },
    generateNewOrderUuid: ({ commit }) => {
      commit('GENERATE_NEW_ORDER_UUID');
    },
    setExtraInstructions: ({ commit }, { instructions }: { instructions: string }) => {
      commit('SET_EXTRA_INSTRUCTIONS', instructions);
    },
    clearReference: ({ commit }) => {
      commit('CLEAR_REFERENCE');
    },
    clearCustomer: ({ commit }) => {
      commit('CLEAR_CUSTOMER');
    },
    clearExtraInstructions: ({ commit }) => {
      commit('CLEAR_EXTRA_INSTRUCTIONS');
    },
    setCustomsInvoiceUuid: ({ commit }, { uuid }: { uuid: string | null }) => {
      commit('SET_CUSTOMS_INVOICE_UUID', uuid);
    },
    clearCustomsInvoiceUuid: ({ commit }) => {
      commit('CLEAR_CUSTOMS_INVOICE_UUID');
    },
    createCustomer: async ({ commit }, { customerData }: { customerData: NafoCustomer }) => {
      const res = await postNafoCustomer(customerData);
      commit('SET_CUSTOMER', res);
    },
    updateCustomer: async ({ commit }, { customerId, payload }: { customerId: string; payload: NafoCustomer }) => {
      const res = await patchNafoCustomer(customerId, payload);
      commit('SET_CUSTOMER', res);
    },
  },
  getters: {
    hasCustomer: (state: State): boolean => !!state.customer,
    getCustomer: (state: State): NafoCustomer => state.customer,
    getReference: (state: State): string => state.reference,
    getExtraInstructions: (state: State): string => state.extraInstructions,
    getOrderUuid: (state: State): string => state.orderUUid,
    getCustomsInvoiceUuid: (state: State): string | null => state.customsInvoiceUuid,
  },
};
